import React from 'react';
import Client from './Layout/Client';
import { Container } from './styles';

export function MobileFooter(props) {
	const { layout, notificacoes, dataNotification } = props;
	return (
		<div className="d-block d-sm-block d-md-block d-lg-none">
			<Container className="d-flex">
				{layout === 'client' &&
				<Client
					notificacoes={notificacoes}
					dataNotification={dataNotification}
				/>}
			</Container>
		</div>
	);
}
